import { Injectable } from "@angular/core";
import { IOverflowError } from "../../core/interfaces/overflow-error.interface";
import { OverflowErrorsDataService } from "../data/overflow-errors-data.service";

@Injectable({
  providedIn: "root",
})
export class OverflowErrorsRemoteService {
  constructor(private overflowErrorsDataService: OverflowErrorsDataService) {}

  public searchOverflowErrorsData(errorCode: string): IOverflowError {
    return this.overflowErrorsDataService
      .getOverflowErrorsData()
      .find(
        (overflowError: IOverflowError) =>
          overflowError.errorCode === errorCode,
      );
  }
}
